import clsx from 'clsx';
import { getUrl, Routes } from 'lightning-common/lib/routing';
import { ReactNode } from 'react';

interface GhostLoginButtonProps {
    label: ReactNode;
    slots?: {
        button?: {
            classes?: string;
        },
        form?: {
            classes?: string;
        }
    }
}

export const GhostLoginButton = ({ label, slots }: GhostLoginButtonProps) => (
    <form 
        action={getUrl(Routes.ozone.external, {forwardUrl: window.location.href})}
        className={clsx(slots?.form?.classes)}
        id="target" 
        method="post">
        <input type="hidden" name="authType" value="External" />
        <input type="hidden" name="ilsName" value="_ghost" />

        <button
            className={clsx(slots?.button?.classes)}
            tabIndex={-1}
            type="submit">
            {label}
        </button>
    </form>
);
